<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="customer-main-sidebar" position="left" lockedOpen="gt-md">
        <customer-main-sidebar></customer-main-sidebar>
    </fuse-sidebar>

    <!-- CENTER -->
    <div class="center">
        <div class="content-card" style="overflow-y: scroll;">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="p-24">
                    <ngx-datatable
                        #table
                        class="material"
                        [rows]="rows"
                        [loadingIndicator]="loadingIndicator"
                        [columnMode]="'force'"
                        [headerHeight]="48"
                        [footerHeight]="56"
                        [rowHeight]="'auto'"
                        [scrollbarH]="true"
                        [reorderable]="reorderable"
                        [selectionType]="'checkbox'"
                        [externalPaging]="true"
                        [count]="page.totalElements"
                        [offset]="page.pageNumber"
                        [limit]="page.size"
                        (page)="setPage($event)">

                        <ngx-datatable-column name="{{'Name' | translate}}" prop="name">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.name}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Active from' | translate}}" prop="createdAt">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.activeFromDate | date:'dd.MM.yyyy H:mm:ss':'UTC': 'pl'}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Active to' | translate}}" prop="createdAt">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.expirationDate | date:'dd.MM.yyyy H:mm:ss':'UTC': 'pl'}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Created at' | translate}}" prop="createdAt">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.createdAt | date:'dd.MM.yyyy H:mm:ss':'UTC': 'pl'}}
                            </ng-template>
                        </ngx-datatable-column>




                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>
